import { PayloadAction } from '@reduxjs/toolkit';

import { ContentReducerCreator } from '../types';
import { StaticVideo } from '@/types/video.types';

const editUploadedVideoReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<StaticVideo>) => {
    if (!state.uploadedVideos) return;

    state.uploadedVideos = state.uploadedVideos?.map((video) => {
      if (video.uuid === action.payload.uuid) {
        return action.payload;
      }

      return video;
    });
  });
};

export default editUploadedVideoReducer;
